import { registerFeatureWithDescription } from "lib/features"

export const FEATURE_FLAG_SHARE_LINK_COMMENTS = registerFeatureWithDescription({
    numericalId: 22,
    id: "share-link-comments",
    name: "Share-Link Comments",
    readyForBeta: true,
    descriptionLines: [
        "Allows share-link recipients and internal users to discuss shared maintenance schedules from the schedule view.",
    ],
})
